import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { Figure, RichText } from '@printdeal/ui-library';
import { Image, Source } from '@unpic/react';
import { Markdown } from '@printdeal/markdown/react';
import clsx from 'clsx';
import { Markdown as IMarkdown } from '../../types/markdown';

const seoImageQuery = graphql`
  query {
    seoContentWidget: contentfulModuleMedia(title: { eq: "SeoContent" }) {
      media {
        title
        url
        width
        height
      }
    }
  }
`;

interface SeoContentProps {
  content: IMarkdown;
  className?: string;
}

const breakpoints = [320, 640, 950, 1256];

const SeoContent = ({ content, className }: SeoContentProps) => {
  const { seoContentWidget } = useStaticQuery(seoImageQuery);

  return (
    <div
      data-testid="SeoContent"
      className={clsx('pd-flex pd-flex-col pd-items-center', className)}
    >
      {seoContentWidget?.media && (
        <Figure as="picture" className="pd-max-h-80 lg:pd-h-96 lg:pd-max-h-none">
          {['avif', 'webp', null].map((format) => (
            <Source
              key={format || 'default'}
              src={`${seoContentWidget.media.url}?fm=${format || ''}`}
              width={seoContentWidget.media.width}
              height={seoContentWidget.media.height}
              type={format && `image/${format}`}
              breakpoints={breakpoints}
            />
          ))}
          <Image
            layout="constrained"
            width={seoContentWidget.media.width}
            height={seoContentWidget.media.height}
            src={seoContentWidget.media.url}
            alt={seoContentWidget.media.title}
            breakpoints={breakpoints}
            className="pd-aspect-[2/1] pd-size-full pd-object-center"
            priority={false}
          />
        </Figure>
      )}

      <div className="pd-max-w-4xl pd-rounded-md pd-bg-white pd-p-3 lg:pd-relative lg:-pd-mt-32 lg:pd-p-12">
        {content?.childMarkdownRemark?.rawMarkdownBody && (
          <RichText as="article">
            <Markdown>{content.childMarkdownRemark.rawMarkdownBody}</Markdown>
          </RichText>
        )}
      </div>
    </div>
  );
};

export default SeoContent;
